import { Box } from '@mui/material';
import { PageSkeleton } from '../table-skeleton';

export default function RouteFallback() {
  return (
    <Box sx={{ width: '100%', px: { xs: 0, md: 1 }, py: 1 }}>
      <PageSkeleton />
    </Box>
  );
}
